export const ROUTE_TYPE_REDIRECT = 'redirect';
export const ROUTE_BASE_PATH = '/';

export const ROUTE_PATH = Object.freeze({
  BASE: ROUTE_BASE_PATH,
  HOME: '/home',
  ONBOARDING: '/onboarding',
  WELCOME: '/welcome',
  AUTOMATIC_QUOTER: '/automatic-quoter',
  QUOTER: '/quoter/:type/:step',
  SERVICES: '/services',
  STORES: '/stores',
  DOCUMENTS: '/documents',
  ESTADO_CUENTA: '/estado-cuenta',
  STORE: '/store',
  BILLING: '/billing',
  SETTINGS: '/settings/:section',
  LOGIN: '/login',
  REGISTRATION: '/registration/:step',
  RECOVER_PASSWORD: '/password/recover',
  RESET_PASSWORD: '/auth/password/reset',
  LOGOUT: '/logout',
  SESSION_CLOSED: '/session-closed',
  INACTIVE_SESSION: '/inactive-session',
  ERROR: '/error/:status',
  WHO_WE_ARE: '/who-we-are',
  PROFILE: '/profile',
  PROFILE_EDIT: '/profile/edit',
  PROFILE_INTERBANK_KEY: '/profile/interbank-key',
  PAYMENTS: '/payments',
  RECEIPTS_HISTORY: '/receipts-history',
  PAYMENTS_MULTIPLE: '/payments/multiple',
  PAYMENT_GATEWAY: '/payment-gateway',
  EXECUTIVE_DRIVER: '/executive-driver',
  APPOINTMENT: '/appointment',
  CHAT: '/chat',
  CONTRACT: '/contracts/:id',
  SECTION: '/sections/:id',
  CONTRACT_PAYMENT: '/contracts/:id/payment',
  SECTION_PAYMENT: '/sections/:id/payment',
  FINSUS: '/finsus',
  GESTOPAGO: '/gestopago',
  KLU: '/klu',
  AUCTIONS: '/auctions',
  LOYALTY_POINTS_PROMOTIONS: '/loyalty-points/promotions',
  LOYALTY_POINTS_COUPONS: '/loyalty-points/coupons',
  LOYALTY_POINTS_COUPON: '/loyalty-points/coupons/:id',
  REFERRALS: '/referrals',
  NOTIFICATIONS: '/notifications',
  BBVA_RESPONSE: '/bbva/:type/:id/payments/:referenceId/:status',
  BBVA_RESPONSE_MULTIPLE: '/bbva/packages/:packageId/:status',
  BBVA_REDIRECT: '/bbva/redirect/:step',
  APP: '/app',
  TERMS_AND_CONDITIONS: '/terminos-y-condiciones',
  DIGITAL_LOAN: '/digital-loan/:step',

  setQuoter: (type, step = 'start') => `/quoter/${type}/${step}`,
  setDigitalLoan: (step = 'intro') => `/digital-loan/${step}`,
  setSignup: (step = '') => `/signup${step ? `/${step}` : ''}`,
  setRegistration: (step = 'start') => `/registration/${step}`,
  setSettings: (section = 'general') => `/settings/${section}`,
  setStores: (step = '') => `/stores${step ? `/${step}` : ''}`,
  setAutomaticQuoter: (from) => `/automatic-quoter${from ? `?from=${from}` : ''}`,
  setError: (status) => `/error/${status}`,
  setContract: (contractId) => `/contracts/${contractId}`,
  setSection: (sectionId) => `/sections/${sectionId}`,
  setContractPayment: (contractId) => `/contracts/${contractId}/payment`,
  setSectionPayment: (sectionId) => `/sections/${sectionId}/payment`,
  setBBVARedirect: (step = 'init') => `/bbva/redirect/${step}`,
  setLoyaltyPointsCoupon: (couponId) => `/loyalty-points/coupons/${couponId}`,
  setNotification: (id) => `/notifications/${encodeURIComponent(id)}`,
  setKlu: (goToLogin = false) => `/klu${goToLogin ? '?login=true' : ''}`,
});
